import { render, staticRenderFns } from "./WFLine.vue?vue&type=template&id=3842d802&scoped=true"
import script from "./WFLine.vue?vue&type=script&lang=js"
export * from "./WFLine.vue?vue&type=script&lang=js"
import style0 from "./WFLine.vue?vue&type=style&index=0&id=3842d802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842d802",
  null
  
)

export default component.exports